import { useEffect, useState } from 'react';
import { DataView, LoadingComponent } from 'usbc-web-react-library';
import useManageApi from '../../hooks/useManageApi';
import CertificateItem from './CertificateItem';
import { info_icon } from '../shared/iconSvgs';
import { useNavigate } from "react-router-dom";
import './Certificates.css'
import ValidationErrors from '../shared/ValidationErrors';

const Certificates = () => {
    const { getCertificates, loading: certificatesLoading } = useManageApi();
    const { getAspTrainingAvailable, loading: aspTrainingAvailableLoading } = useManageApi();
    const [aspTrainingAvailable, setAspTrainingAvailable] = useState(null);
    const [certificatesViewModel, setCertificatesViewModel] = useState(null);
    const [validationErrors, setValidationErrors] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        getAspTrainingAvailable().then((result) => {
            setAspTrainingAvailable(result.data);
        });
        getCertificates({
            onError: (errors) => {
                setValidationErrors(errors);
                // Scroll to the top of the page
                window.scrollTo(0, 0);
            }
        }).then((result) => {
            if(result?.data?.certificatesModel){
                setCertificatesViewModel(result.data.certificatesModel);
            }
            if(result?.data?.redirectUrl){
               navigate(result?.data?.redirectUrl);
            }
        });
    }, []);

    function certificateItemTemplate(certificate, index, layout) {
        return <CertificateItem certificate={certificate} index={index} layout={layout} />;
    }

    function handleTermsAndConditionsRedirect() {
        window.location.href = "/AthleteSafetyPortal/AthleteSafetyRVP/TermsAndConditions?returnUrl=Certificates"
    }

    function headerTemplate(layout) {
        return <tr>
            <th scope="col">Course Name</th>
            <th scope="col">Completion Date</th>
            <th scope="col">Certificate</th>
        </tr>;
    }

    return (
        <div className='certificates'>
            {validationErrors && <ValidationErrors className="validation-errors alert alert-danger mt-3" validationErrors={validationErrors} />}
            <LoadingComponent isLoading={() => aspTrainingAvailableLoading} description={"Loading... Please Wait"}>
                {aspTrainingAvailable === false &&
                    <div className="rvp-header-card card alert alert-warning">
                        <div className="row g-0">
                            <div className="rvp-header-card-icon col-md-1 d-flex flex-wrap align-content-center justify-content-center">
                                {info_icon}
                            </div>
                            <div className="rvp-header-card-text col-md-11 container">
                                <div style={{ fontWeight: 'bold' }}>IMPORTANT NOTICE</div>
                                <div>The Athlete Safety Portal is currently down for maintenance. During this timeframe access will be unavailable.</div>
                            </div>
                        </div>
                    </div>
                }
                {aspTrainingAvailable === true &&
                    <LoadingComponent isLoading={() => certificatesLoading}
                        description={"Loading Certificates... Please Wait."}>
                        {certificatesViewModel?.isError === true &&
                            <div className="rvp-header-card card alert alert-danger">
                                <div className="rvp-header-card-text container">
                                    There was an issue getting user certificate information, please contact support.
                                </div>
                            </div>
                        }
                        {certificatesViewModel?.isError === false
                            && certificatesViewModel?.trainedCertificates === null && certificatesViewModel?.termsAndConditionsText &&
                            <div>
                                <h4>Athlete Safety - SafeSport Certificates</h4>
                                <br />
                                <div><label>SafeSport Terms and Conditions must be approved prior to accessing your certificates.</label></div>
                                <br />
                                <div className="text-center">
                                    <a id="acceptterms" type="button" role="button" className="btn btn-primary btn-block" onClick={handleTermsAndConditionsRedirect}>SafeSport Training Terms and Conditions</a>
                                </div>
                                <br />
                            </div>
                        }
                        {certificatesViewModel?.isError === false
                            && certificatesViewModel?.trainedCertificates === null && !certificatesViewModel?.termsAndConditionsText &&
                            <div>
                                <h4>Athlete Safety - SafeSport Certificates</h4>
                                <br />
                                <div className=" text-left" style={{ color: "blue" }}><label>SafeSport certificates will be shown in this area after a SafeSport course is completed.  SafeSport courses are available to any USBC member in the Athlete Safety / RVP tab.</label></div>
                                <br />
                            </div>
                        }
                        {certificatesViewModel?.isError === false
                            && certificatesViewModel?.trainedCertificates !== null &&
                            <>
                                <h4>Athlete Safety - SafeSport Certificates</h4>
                                <DataView data={certificatesViewModel?.trainedCertificates}
                                    itemTemplate={certificateItemTemplate}
                                    headerTemplate={headerTemplate}
                                    defaultLayout={1}
                                    onColumnsCountChanged={() => { }}
                                    emptyText="No Certificates Found" emptyIcon={<i className="bi bi-person-x"></i>}
                                    hideLayoutSwitch={true}
                                />
                            </>
                        }
                    </LoadingComponent>
                }
            </LoadingComponent>
            <br />
            <span>
                Should you have any questions about the SafeSport certificates, please go to <a href="http://www.Bowl.com/RVP" target="_blank" rel="noopener noreferrer">BOWL.com/RVP</a> or contact <a href="mailto:RegisteredVolunteers@bowl.com?subject=Registered%20Volunteer%20Question" target="_blank">RVP@bowl.com</a>.
            </span>
            
        </div>
    );
}

export default Certificates